<template>
  <div>
    <PageHeader :title="title" :items="items"/>
    <router-view></router-view>
  </div>
</template>

<script>

export default {
  name: "Index",
  data() {
    return {
      title: this.$t('pages.template_builder.title'),
      items: [
        {
          text: this.$t('pages.template_builder.items.first'),
          href: "/",
        },
        {
          text: this.$t('pages.template_builder.items.second'),
          active: true,
        },
      ],
    }
  },
}
</script>

<style scoped>

</style>